import { useDispatch, TypedUseSelectorHook, useSelector } from 'react-redux'
import { TypedDispatch, IRootState } from 'reducers'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<TypedDispatch>()

export const useAppSelector: TypedUseSelectorHook<IRootState> = useSelector
